import axios from 'axios';
import { config as appConfig } from '../config';

const baseURL = appConfig.screenappBackendBaseUrl;

const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);

export const setHeader = (accessToken:string) => {
  api.interceptors.request.use((config) => {
    config.headers.Authorization = accessToken ? `Bearer ${accessToken}` : '';
    return config;
  });
};

export default api;
